/*
 * The live content views english translation
 */
export const LIVE_CONTENT_VIEW_EN = {
  title: 'Title',
  columnTitle: 'Title',
  article: 'Article',
  source: 'Source',
  date: 'Date',
  noTitle: 'No Title',
  noArticlesFound: 'No articles found for:',
  articlesSelected: 'articles selected',
  addContent: 'Add Content',
  showBookmark: 'Show Bookmarks',
  functionNotUnlocked: 'Function not unlocked',
  personalizedContentDatabase:
    'Our team would be happy to set up your personalized content database for an additional fee.'
}
/*
 * The live content views german translation
 */
export const LIVE_CONTENT_VIEW_DE = {
  title: 'Titel',
  columnTitle: 'Titel',
  article: 'Artikel', // TODO: this is in context of live content items
  source: 'Quelle',
  date: 'Datum',
  noTitle: 'Kein Titel',
  noArticlesFound: 'Keine Artikel gefunden für:',
  articlesSelected: 'Artikel ausgewählt',
  addContent: 'Inhalt hinzufügen',
  showBookmark: 'Lesezeichen anzeigen',
  functionNotUnlocked: 'Funktion nicht freigeschalten',
  personalizedContentDatabase:
    'Unser Team richtet ihnen gerne Ihre personalisierte Content Datenbank für einen Aufpreis ein.'
}
